var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57143 0L0.632441 2.56138C0.221808 2.91928 0 3.43559 0 4.04762C0 6.09107 1.99051 9.3824 5.47619 12.3452C8.96188 15.3081 12.834 17 15.2381 17C15.9582 17 16.5655 16.8114 16.9866 16.4624L20 13.9643L15.2381 9.91667L12.381 12.1429C10.9534 11.4632 9.67405 10.6539 8.57143 9.71429C7.45477 8.76269 6.51886 7.67746 5.71429 6.47619L8.33333 4.04762L3.57143 0ZM10.4762 0V5.2619H11.9048V6.88095L14.0476 5.2619H20V0H10.4762ZM12.8571 2.02381C13.2516 2.02381 13.5714 2.29564 13.5714 2.63095C13.5714 2.96627 13.2516 3.2381 12.8571 3.2381C12.4627 3.2381 12.1429 2.96627 12.1429 2.63095C12.1429 2.29564 12.4627 2.02381 12.8571 2.02381ZM15.2381 2.02381C15.6326 2.02381 15.9524 2.29564 15.9524 2.63095C15.9524 2.96627 15.6326 3.2381 15.2381 3.2381C14.8436 3.2381 14.5238 2.96627 14.5238 2.63095C14.5238 2.29564 14.8436 2.02381 15.2381 2.02381ZM17.619 2.02381C18.0135 2.02381 18.3333 2.29564 18.3333 2.63095C18.3333 2.96627 18.0135 3.2381 17.619 3.2381C17.2246 3.2381 16.9048 2.96627 16.9048 2.63095C16.9048 2.29564 17.2246 2.02381 17.619 2.02381Z",
    fill: "#B1BADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.83515ce319fcbf819c9be032d633091f.svg";
export { ForwardRef as ReactComponent };